import axiosAPI from '../../utils/client/axiosAPI';
import { DashboardResponse, UpcomingEvent } from './contracts';

export interface OrdersByCategoryResponse {
  kategorija: string;
  narudzbine: number;
}

export interface RevenueOverTimeResponse {
  mesec: string;
  prihod: number;
}

export class Dashboard {
  static async getMetrics(): Promise<DashboardResponse> {
    const response = await axiosAPI.get<DashboardResponse>('admin/dashboard');
    return response.data;
  }

  static async getOrdersByCategory(start?: Date, end?: Date): Promise<OrdersByCategoryResponse[]> {
    let url = 'admin/dashboard/orders-by-category';
    if (start && end) {
      url += `?start=${start.toISOString()}&end=${end.toISOString()}`;
    }
    const response = await axiosAPI.get<OrdersByCategoryResponse[]>(url);
    return response.data;
  }

  static async getRevenueOverTime(start?: Date, end?: Date): Promise<RevenueOverTimeResponse[]> {
    let url = 'admin/dashboard/revenue-over-time';
    if (start && end) {
      url += `?start=${start.toISOString()}&end=${end.toISOString()}`;
    }
    const response = await axiosAPI.get<RevenueOverTimeResponse[]>(url);
    return response.data;
  }

  static async getUpcomingEvents(): Promise<UpcomingEvent[]> {
    const response = await axiosAPI.get<UpcomingEvent[]>('admin/dashboard/upcoming-events');
    return response.data;
  }

  static async getCounts(): Promise<{ products: number; categories: number; orders: number; media: number }> {
    const response = await axiosAPI.get<{ products: number; categories: number; orders: number; media: number }>('admin/dashboard/counts');
    return response.data;
  }
}
